export default {
 
    SET_MERCADO_AUTH(state, payload) {
        state.mercadoAuth = payload
        state.conectado   = payload != null
    },
 
    SET_MERCADO_PENDING(state, value) {
        state.mercadoPending = value
    },
 
    SET_MERCADO_PRODUCT_STATUS(state, payload) {
        state.mercadoProductStatus = payload
        state.mercadoCategoryPrediction = payload && payload.category_prediction
            ? payload.category_prediction
            : null
        state.mercadoIncident = payload && payload.ml_incident 
            ? payload.ml_incident
            : null
    },
 
    SET_MERCADO_CATEGORY_PREDICTION(state, payload) {
        state.mercadoCategoryPrediction = payload
    },
 
    SET_MERCADO_CATEGORIES(state, payload) {
        state.mercadoCategories = payload
    },
 
    SET_MERCADO_CATEGORY_ATTRIBUTES(state, payload) {
        state.mercadoCategoryAttributes = payload || []
    },
 
    RESET_MERCADO_ATTRIBUTES(state) {
        state.mercadoCategoryAttributes = []
    },
 
    SET_MERCADO_PUBLISHING(state, value) {
        state.mercadoPublishing = value
    },
 
    SET_MERCADO_LISTING_TYPES(state, payload) {
        state.mercadoListingTypes = payload || []
    },
 
    SET_MERCADO_PUBLISH_ERROR(state, payload) {
        state.mercadoPublishError = payload
    },
 
    SET_MERCADO_PRODUCT_PRICES(state, payload) {
        state.mercadoProductPrices = payload || []
    },
 
    SET_MERCADO_LOADING_PRICES(state, value) {
        state.mercadoLoadingPrices = value
    },

    SET_MERCADO_AVAILABLE_ITEMS(state, payload) {
    state.mercadoAvailableItems = payload || []
    },
    SET_MERCADO_AVAILABLE_ITEMS_PAGING(state, payload) {
        state.mercadoAvailableItemsPaging = payload || {}
    },
    SET_MERCADO_AVAILABLE_ITEMS_LOADING(state, value) {
        state.mercadoAvailableItemsLoading = value
    },
    SET_MERCADO_LINKED_ITEM(state, payload) {
        state.mercadoLinkedItem = payload
    },
    SET_MERCADO_LINKED_ITEM_LOADING(state, value) {
        state.mercadoLinkedItemLoading = value
    },
     SET_MERCADO_INCIDENT(state, payload) {
        state.mercadoIncident = payload || null
    },
    SET_ML_TRANSFERS(state, payload) {
    state.mlTransfers = payload || []
    },
    SET_ML_TRANSFERS_LOADING(state, value) {
        state.mlTransfersLoading = value
    },
    SET_ML_TRANSFERS_PARAMS(state, payload) {
        state.mlTransfersParams = { ...state.mlTransfersParams, ...payload }
    },
}


// WEBPACK FOOTER //
// ./src/modules/mercado-api/mutations.js